var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.828,
    height: 21.422,
    viewBox: "0 0 18.828 21.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(1.306 6.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M62.205,150l1.112,13.42a1.893,1.893,0,0,0,1.875,1.727H75.435a1.893,1.893,0,0,0,1.875-1.727L78.422,150Zm4.97,12.636a.628.628,0,0,1-.626-.588l-.628-10.125a.628.628,0,0,1,.587-.666.618.618,0,0,1,.666.587l.628,10.125A.628.628,0,0,1,67.175,162.636Zm3.766-.628a.628.628,0,1,1-1.255,0V151.883a.628.628,0,1,1,1.255,0Zm3.764-10.086-.628,10.125a.628.628,0,1,1-1.253-.078l.628-10.125a.638.638,0,0,1,.666-.587A.628.628,0,0,1,74.705,151.922Z",
    transform: "translate(-62.205 -150)",
    fill: "#b3b3b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M48.573,2.51H44.807V1.883A1.885,1.885,0,0,0,42.924,0H37.9a1.885,1.885,0,0,0-1.883,1.883V2.51H32.255a1.255,1.255,0,0,0,0,2.51H48.573a1.255,1.255,0,0,0,0-2.51Zm-5.021,0H37.276V1.883a.628.628,0,0,1,.628-.628h5.021a.628.628,0,0,1,.628.628Z",
    transform: "translate(-31)",
    fill: "#b3b3b3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.175011da9beb16460cf40188961e1ab8.svg";
export { ForwardRef as ReactComponent };